import common from './common';
import login from './login';
import lounge from './lounge';
import member from './membership';
import account from './account';

// 导出接口
export default {
  common,
  login,
  lounge,
  member,
  account,
};
